<template>
  <div class="content garden">
    <div class="map">
      <div :id="'garden'+tag"></div>
    </div>
    <div class="rightSurvey">
      <div class="banner">
        <el-carousel trigger="click" height="540px" autoplay indicator-position="none">
          <el-carousel-item v-for="item in currentGarden.picList" :key="item">
            <img :src="item" alt />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="info">
        <marquee
          class="left"
          width="330"
          height="335"
          behavior="scroll"
          direction="up"
          scrollamount="5"
        >
          <p style="fontSize:18px;text-align:center">{{currentGarden.name}}</p>
          <p style="fontSize:12px;line-height:20px;">{{currentGarden.intro}}</p>
        </marquee>
        <div class="right">
          <p style="fontSize:18px;text-align:center">园区基本情况</p>
          <p>园区类型：{{currentGarden.type}}</p>
          <p>园区主导产业：{{currentGarden.mainIndustry}}</p>
          <p>工业总产值：{{currentGarden.total}}</p>
          <p>企业个数：{{currentGarden.companyNum}}</p>
          <p>工业企业个数：{{currentGarden.industryCompanyNum}}</p>
          <p>园区级别：{{currentGarden.level}}</p>
          <p>营业收入：{{currentGarden.income}}</p>
          <p>从业人员：{{currentGarden.employee}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MapJson } from "@/assets/mapJson.js";
export default {
  data() {
    return {
      //当前园区
      currentGarden: {},
      //园区列表
      totalGardenPicList: [
        {
          picList: [
            require("../../../assets/imgs/image/garden_gdzb_1.png"),
            require("../../../assets/imgs/image/garden_gdzb_2.png")
          ],
          name: "高端装备园区"
        },
        {
          picList: [require("../../../assets/imgs/image/garden_ylqc_1.png")],
          name: "银隆新能源产业园"
        },
        {
          picList: [
            require("../../../assets/imgs/image/garden_glzz_1.png"),
            require("../../../assets/imgs/image/garden_glzz_2.png")
          ],
          name: "格力智造产业园"
        },
        {
          picList: [require("../../../assets/imgs/image/garden_gdjt_1.png")],
          name: "轨道交通产业园"
        },
        {
          picList: [
            require("../../../assets/imgs/image/garden_dsj_1.png"),
            require("../../../assets/imgs/image/garden_dsj_2.png")
          ],
          name: "大数据产业园"
        }
      ],
      //所有地区园区列表
      allTotalGardenList: [],
      //园区列表
      totalGardenList: [],
      //园区使用的数据数组
      gardenValue: [
        {
          name: "洛龙区",
          garden: "大数据产业园"
        },
        {
          name: "偃师市",
          garden: "高端装备产业制造园"
        },
        {
          name: "吉利区",
          garden: "格力智能制造产业基地、银隆新能源产业园"
        },
        {
          name: "瀍河回族区",
          garden: "轨道交通产业园"
        },
        {
          name: "栾川县",
          garden: ""
        },

        {
          name: "伊川县",
          garden: ""
        },
        {
          name: "洛宁县",
          garden: ""
        },
        {
          name: "宜阳县",
          garden: ""
        },
        {
          name: "孟津县",
          garden: ""
        },
        {
          name: "嵩县",
          garden: ""
        },
        {
          name: "汝阳县",
          garden: ""
        },
        {
          name: "新安县",
          garden: ""
        },
        {
          name: "涧西区",
          garden: ""
        },
        {
          name: "西工区",
          garden: ""
        },

        {
          name: "老城区",
          garden: ""
        }
      ],
      //打点的坐标信息
      geoCoordMap: {
        老城区: [112.477298, 34.682945],
        涧西区: [112.399243, 34.654251],
        西工区: [112.443232, 34.667847],
        瀍河回族区: [112.491625, 34.684738],
        吉利区: [112.584796, 34.899093],
        洛龙区: [112.456634, 34.618557],
        新安县: [112.141403, 34.728679],
        孟津县: [112.443892, 34.826485],
        嵩县: [112.087765, 34.131563],
        栾川县: [111.618386, 33.783195],
        汝阳县: [112.473789, 34.15323],
        宜阳县: [112.179989, 34.516478],
        洛宁县: [111.655399, 34.387179],
        伊川县: [112.429384, 34.423416],
        偃师市: [112.787739, 34.723042]
      },
      //模拟数据  首个留一个空
      locValue: [
        {},
        { name: "洛龙区", value: "480", garden: "大数据产业园" },
        { name: "偃师市", value: "400", garden: "高端装备产业制造园" },
        {
          name: "吉利区",
          value: "350",
          garden: "格力智能制造产业基地、银隆新能源产业园"
        },
        { name: "瀍河回族区", value: "300", garden: "轨道交通产业园" },
        { name: "栾川县", value: "100", garden: "" },
        { name: "伊川县", value: "100", garden: "" },
        { name: "洛宁县", value: "100", garden: "" },
        { name: "宜阳县", value: "100", garden: "" },
        { name: "孟津县", value: "100", garden: "" },
        { name: "汝阳县", value: "100", garden: "" },
        { name: "嵩县", value: "100", garden: "" },
        { name: "新安县", value: "100", garden: "" },
        { name: "老城区", value: "100", garden: "" },
        { name: "涧西区", value: "100", garden: "" },
        { name: "西工区", value: "100", garden: "" }
      ],
      seat: "",
      timeTicket: null
    };
  },
  props: ["tag"],
  methods: {
    //获取园区检测数据
    queryParkInfo() {
      this.$axios
        .get("/business/park/queryParkInfo")
        .then(res => {
          this.allTotalGardenList = JSON.parse(JSON.stringify(res.data));

          // console.log("园区数据获取", this.tag);
          // console.log("allTotalGardenList1111",this.allTotalGardenList);
        })
        .catch(res => {
          console.log("获取园区监测数据失败", res);
        });
    },
    //处理数据
    convertData(geoCoordMap, data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var geoCoord = geoCoordMap[data[i].name];
        if (data.garden && geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value),
            garden: data[i].garden
          });
        }
        if (!data.garden && geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value)
          });
        }
      }
      // for (let j = 0; j < res.length; j++) {
      //   res[j].value[2] = res[j].value[2];
      // }
      return res;
    },
    //园区地图
    getGardenMap() {
      let _this = this;

      function getMap(data) {
        _this.$echarts.registerMap("luoyang", data);
        var inverstChart = _this.$echarts.init(
          document.getElementById("garden")
        );
        _this.setGardenOption(inverstChart);
      }
      getMap(MapJson);
    },
    //园区地图应用配置
    setGardenOption(inverstChart) {
      let _this = this;
      var inverstMapOption = {
        color: ["#D01864", "#F2F832", "#25CEF3"],
        backgroundColor: "rgba(255,255,255,0)", //背景色
        title: {
          text: "", //标题内容
          x: "center", //标题位置
          textStyle: {
            color: "#fff" //标题颜色
          }
        },
        tooltip: {
          //提示信息
          trigger: "item",
          formatter: function(params) {
            var result;
            var local;
            for (let i = 0; i < _this.gardenValue.length; i++) {
              if (_this.gardenValue[i].name == params.data.name) {
                result = _this.gardenValue[i].garden;
                local = _this.gardenValue[i].name;
                break;
              }
            }

            if (local == "偃师市") local = "伊滨区"; //地图里面没有伊滨区 高新区这两个  两个区的位置在 偃师市 吉利区  看情况做修正
            if (local == "吉利区") local = "高新区";
            _this.seat = local;
            _this.cutGarden();
            return local + "：" + result;
          },
          extraCssText: "background:#0ADAFF;padding:20px 10px", //编辑tooltip的css样式
          textStyle: {
            fontSize: 22
          }
        },

        geo: {
          //地图配置
          map: "luoyang",
          roam: false, //开启缩放scale 和拖动move  true 同时开启
          aspectScale: 1, //地图长宽比
          selectedMode: "single", //鼠标点击选中
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#2B91B7",
              borderColor: "#111",
              shadowBlur: 1,
              shadowColor: "#5F6476",
              shadowOffsetX: 2,
              shadowOffsetY: 2
            },
            emphasis: {
              areaColor: "aqua",
              shadowBlur: 1,
              shadowColor: "#5F6476",
              shadowOffsetX: 3,
              shadowOffsetY: 3
            }
          }
        },
        series: [
          {
            name: "园区地址",
            type: "effectScatter", //涟漪特效散点图
            showEffectOn: "render", //涟漪特效展示时机
            rippleEffect: {
              //涟漪特效配置
              scale: 15, //涟漪扩散倍数
              period: 10 //涟漪动画周期
              // brushType: 'stroke'
            },
            markPoint: {
              color: "red"
            },
            hoverAnimation: true,
            coordinateSystem: "geo",
            data: _this //暂时自定义处理数据
              .convertData(_this.geoCoordMap, _this.locValue)
              .slice(0, 4), //取出具有园区的县
            symbolSize: function(val) {
              //图标大小
              return val[2] / 50;
            },
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: true,
                color: "#fff"
              },
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              emphasis: {
                borderColor: "#fff",
                borderWidth: 1
              }
            },
            zlevel: 1
          },
          {
            type: "map",
            map: "luoyang",
            geoIndex: 0,
            aspectScale: 1, //长宽比
            showLegendSymbol: false, // 存在legend时显示
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false,
                textStyle: {
                  color: "#fff"
                }
              }
            },
            roam: false,
            animation: false,
            data: _this.locValue.map(res => {
              res = { name: res.name, value: 0 };
              return res;
            }),
            itemStyle: {
              normal: {
                areaColor: "#031525",
                borderColor: "#FFFFFF"
              },
              emphasis: {
                areaColor: "#2B91B7"
              }
            }
          }
        ]
      };
      inverstChart.setOption(inverstMapOption);
      // inverstChart.on("click", function() {
      //   // alert(params.dataIndex);
      //   // alert(inverstMapOption.series[params.seriesIndex].data[params.dataIndex].name);
      //   // alert(option.series[params.seriesIndex].name)
      // });

      this.autohover(inverstChart, 4);
    },
    //轮播切换tooltips
    autohover(inverstChart, num) {
      var count = 0;
      var timeTicket = null;
      timeTicket && clearInterval(timeTicket);
      timeTicket = setInterval(function() {
        inverstChart.dispatchAction({
          type: "downplay",
          seriesIndex: 1
        });
        inverstChart.dispatchAction({
          type: "highlight",
          seriesIndex: 1,
          dataIndex: count
        });
        inverstChart.dispatchAction({
          type: "showTip",
          seriesIndex: 1,
          dataIndex: count
        });
        if (count >= num) {
          count = 0;
        }
        count++;
      }, 10000);
      // inverstChart.on("mouseover", function(params) {
      //   clearInterval(timeTicket);
      //   inverstChart.dispatchAction({
      //     type: "downplay",
      //     seriesIndex: 0
      //   });
      //   inverstChart.dispatchAction({
      //     type: "highlight",
      //     seriesIndex: 0,
      //     dataIndex: params.dataIndex
      //   });
      //   inverstChart.dispatchAction({
      //     type: "showTip",
      //     seriesIndex: 0,
      //     dataIndex: params.dataIndex
      //   });
      // });
      // inverstChart.on("mouseout", function() {
      //   timeTicket && clearInterval(timeTicket);
      //   timeTicket = setInterval(function() {
      //     inverstChart.dispatchAction({
      //       type: "downplay",
      //       seriesIndex: 0
      //     });
      //     inverstChart.dispatchAction({
      //       type: "highlight",
      //       seriesIndex: 0,
      //       dataIndex: count
      //     });
      //     inverstChart.dispatchAction({
      //       type: "showTip",
      //       seriesIndex: 0,
      //       dataIndex: count
      //     });
      //     if (count >= num) {
      //       count = 0;
      //     }
      //     count++;
      //   }, 1000 * 3);
      // });
    },
    //自动切换工业园
    cutGarden() {
      let _this = this;
      var index = 0; //播放所在下标
      //实时请求最新数据 注释后只在页面打开时加载一次数据，获取最新园区数据需要刷新页面
      // _this.queryParkInfo();

      // setInterval(function() {
      // console.log(_this.seat);
      //根据地区获取产业园数据
      _this.totalGardenList = [];
      for (let i = 0; i < _this.allTotalGardenList.length; i++) {
        if (
          _this.seat != "" &&
          _this.allTotalGardenList[i].seat.indexOf(_this.seat) != -1
        ) {
          _this.totalGardenList.push(_this.allTotalGardenList[i]);
        }
      }
      // console.log(
      //   this.tag,
      //   "自动播放调用",
      //   _this.allTotalGardenList,
      //   _this.totalGardenList
      // );

      var totalLenght = _this.totalGardenList.length;
      if (totalLenght > 0) {
        _this.currentGarden = _this.totalGardenList[index];
        _this.currentGarden.picList = [];
        if (_this.currentGarden != null) {
          var flag = true;
          for (let i = 0; i < _this.totalGardenPicList.length; i++) {
            //根据园区名称匹配图片
            if (_this.totalGardenPicList[i].name == _this.currentGarden.name) {
              for (
                let j = 0;
                j < _this.totalGardenPicList[i].picList.length;
                j++
              ) {
                _this.currentGarden.picList.push(
                  _this.totalGardenPicList[i].picList[j]
                );
              }
              flag = false;
              break;
            }
          }
          //如果匹配不到园区名称，默认给第一组图片
          if (flag) {
            for (
              let i = 0;
              i < _this.totalGardenPicList[0].picList.length;
              i++
            ) {
              _this.currentGarden.picList.push(
                _this.totalGardenPicList[0].picList[i]
              );
            }
          }
        }
        index++;
        if (index >= totalLenght - 1) {
          index = 0;
        }
      }
      // }, 5000);
    },
    triggerAction() {
      //获取园区数据
      this.queryParkInfo();
      this.getGardenMap();
    }
  },
  mounted() {
    this.triggerAction();
  }
};
</script>

<style lang="less" scoped>
.garden {
  justify-content: space-around;
  .map {
    width: 700px;
    height: 720px;
    #garden {
      width: 700px;
      height: 720px;
    }
  }
  .rightSurvey {
    width: 680px;
    height: 720px;
    .banner {
      height: 348px;
      margin-bottom: 30px;
      background: url(../../../assets/imgs/background/garden_banner_bg.png)
        center no-repeat;
      background-size: 680px 348px;
      padding: 6px;
      box-sizing: border-box;
      img {
        width: 674px;
        height: 338px;
        vertical-align: middle;
      }
    }
    .info {
      display: flex;
      justify-content: space-between;
      color: #fff;
      .left {
        background: url(../../../assets/imgs/background/garden_left_bg.png)
          center no-repeat;
        background-size: 330px 335px;
        box-sizing: border-box;
        padding: 0 20px;
      }
      .right {
        width: 330px;
        height: 335px;
        background: url(../../../assets/imgs/background/garden_right_bg.png)
          center no-repeat;
        background-size: 330px 335px;
        box-sizing: border-box;
        padding: 0 20px;
        p {
          font-size: 12px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>